const fastSearchData = {
  Аксесуари: {
    Аптечки: 'Аптечка',
    Батарейка: 'Батарейка',
    Домкрат: 'Домкрат',
    'Жилет світловідбивний': 'Жилет',
    Вогнегасник: 'Огнетушитель',
    Ароматизатор: 'Вонючка',
    'Рамки для номерів': 'Рамка',
    Скребок: 'Скребок',
    'Трос буксирувальний': 'Трос',
    Стяжка: 'Стяжка',
  },

  'Рідини, мастила та засоби': {
    'Очищення та догляд': {
      'Паста, мило для рук': '099996001000',
      'Засіб для очищення двигуна': 'DIMER',
      'Видалення ржавчини': 'SD40/M Smart',
      'Засіб очищення гальм': '21164-0005-99',
      'Засіб догляду за ременями': '090102BS',
      'Смазка силіконова': '4823075803194',
      'Засіб очищення диска': 'ACST505',
      'Засіб догляду за шинами': 'EK1572',
      'Розморожувач замків': '4823075802975',
      'Для скла': {
        'Очисник скла': 'AD0055',
        'Антизапотівник скла': 'TR00181',
        'Розморожувач скла': '4823075804573',
      },
      'Промивка масляної системи': 'XA40201',
    },
    'Омивач скла': {
      Літній: 'Омыватель лето',
      Зимовий: 'Омыватель зима',
    },
    'Дистильована вода': 'Voda',
    Герметик: {
      'Герметик для систем охолодження': 'Stop Leak',
      'Герметик моторний': 'Герметик',
      'Герметик для шин': 'Герметик для шин',
    },

    Антифриз: {
      Зелений: 'зеленый',
      Червоний: 'красный',
      Синій: 'синий',
      Жовтий: 'желтый',
      Фіолетовий: 'фиолетовый',
    },
    'Моторна олива': {
      '0W20': {
        '1 літр': '0w20 1L',
        '4 літри': '0w20 4L',
        '5 літрів': '0w20 5L',
      },
      '0W30': {
        '1 літр': '0w30 1L',
        '4 літри': '0w30 4L',
        '5 літрів': '0w30 5L',
      },
      '0W40': {
        '1 літр': '0w40 1L',
        '4 літри': '0w40 4L',
        '5 літрів': '0w40 5L',
      },
      '5W20': {
        '1 літр': '5w20 1L',
        '4 літри': '5w20 4L',
        '5 літрів': '5w20 5L',
      },
      '5W30': {
        '1 літр': '5w30 1L',
        '4 літри': '5w30 4L',
        '5 літрів': '5w30 5L',
      },
      '5W40': {
        '1 літр': '5w40 1L',
        '4 літри': '5w40 4L',
        '5 літрів': '5w40 5L',
      },
      '5W50': {
        '1 літр': '5w50 1L',
        '4 літри': '5w50 4L',
      },
      '10W30': {
        '1 літр': '10w30 1L',
        '4 літри': '10w30 4L',
      },
      '10W40': {
        '1 літр': '10w40 1L',
        '4 літри': '10w40 4L',
        '5 літрів': '10w40 5L',
      },
      '10W50': {
        '1 літр': '10w50 1L',
        '4 літри': '10w50 4L',
      },
      '10W60': {
        '1 літр': '10w60 1L',
        '4 літри': '10w60 4L',
      },
      '15W40': {
        '1 літр': '15w40 1L',
        '4 літри': '15w40 4L',
      },
      '15W50': {
        '1 літр': '15w50 1L',
        '4 літри': '15w50 4L',
      },
      Бочка: 'бочка',
    },
    'Гальмівна рідина': 'DOT4',
    Присадки: {
      'Для моторної оливи': 'WY 50672',
      Ревіталізант: 'Ревитализант',
      'Присадка дизель': 'ET3121',
      'Присадка до бензину': 'ET3112',
      'Присадка для чистки сажевого фільтра': '22015-0004-99',
    },
    'AdBue (мочевина)': 'AB1',
    'Фіксатори, пасти та клеї': {
      'Фіксатор різьби': 'B151N',
      'Мідна паста': 'BL 288651',
      'Паста для притирки клапанів': 'GP-201',
      'Паста, мило для рук': '099996001000',
      'Епоксидний клей та холодне зварювання': 'Эпоксидка',
    },
  },
  Лампи: {
    C10W: 'C10W',
    C5W: 'C5W',
    D1S: 'D1S',
    D2R: 'D2R',
    D2S: 'D2S',
    D3R: 'D3R',
    D3S: 'D3S',
    H1: 'H1',
    H3: 'H3',
    H4: 'H4',
    H6W: 'H6W',
    H7: 'H7',
    H8: 'H8',
    H9: 'H9',
    H9B: 'H9B',
    H10: 'H10',
    H11: 'H11',
    H12: 'H12',
    H13: 'H13',
    H16: 'H16',
    H18: 'H18',
    H21W: 'H21W',
    'H27W/1': 'H27W/1',
    'H27W/2': 'H27W/2',
    HB1: 'HB1',
    HB3: 'HB3',
    HB4: 'HB4',
    HB5: 'HB5',
    HIR2: 'HIR2',
    'P21/4W': 'P21/4W',
    'P21/5W': 'P21/5W',
    P21W: 'P21W',
    PY21W: 'PY21W',
    R10W: 'R10W',
    R2: 'R2',
    R5W: 'R5W',
    T4W: 'T4W',
    W16W: 'W16W',
    'W21/5W': 'W21/5W',
    W21W: 'W21W',
    W3W: 'W3W',
    W5W: 'W5W',
    WY21W: 'WY21W',
    WY5W: 'WY5W',
  },

  'Кузовні елементи': {
    Двірники: {
      '325 мм': '325mm',
      '330 мм': '330mm',
      '340 мм': '340mm',
      '350 мм': '350mm',
      '360 мм': '360mm',
      '375 мм': '375mm',
      '380 мм': '380mm',
      '400 мм': '400mm',
      '425 мм': '425mm',
      '430 мм': '430mm',
      '450 мм': '450mm',
      '475 мм': '475mm',
      '500 мм': '500mm',
      '525 мм': '525mm',
      '530 мм': '530mm',
      '550 мм': '550mm',
      '560 мм': '560mm',
      '575 мм': '575mm',
      '580 мм': '580mm',
      '600 мм': '600mm',
      '650 мм': '650mm',
      '700 мм': '700mm',
      '750 мм': '750mm',
      '800 мм': '800mm',
    },
    'Гофри глушника': {
      '40x100': 'гофра 40x100',
      '40x200': 'гофра 40x200',
      '40x280': 'гофра 40x280',
      '43x200': 'гофра 43x200',
      '45x100': 'гофра 45x100',
      '45x120': 'гофра 45x120',
      '45x150': 'гофра 45x150',
      '45x190': 'гофра 45x190',
      '45x200': 'гофра 45x200',
      '45x230': 'гофра 45x230',
      '45x260': 'гофра 45x260',
      '45x270': 'гофра 45x270',
      '45x280': 'гофра 45x280',
      '45x320': 'гофра 45x320',
      '45x94': 'гофра 45x94',
      '48x200': 'гофра 48x200',
      '48x230': 'гофра 48x230',
      '50x100': 'гофра 50x100',
      '50x120': 'гофра 50x120',
      '50x150': 'гофра 50x150',
      '50x200': 'гофра 50x200',
      '50x230': 'гофра 50x230',
      '50x250': 'гофра 50x250',
      '50x280': 'гофра 50x280',
      '50x320': 'гофра 50x320',
      '50x95': 'гофра 50x95',
      '55x100': 'гофра 55x100',
      '55x120': 'гофра 55x120',
      '55x150': 'гофра 55x150',
      '55x200': 'гофра 55x200',
      '55x220': 'гофра 55x220',
      '55x230': 'гофра 55x230',
      '55x250': 'гофра 55x250',
      '55x255': 'гофра 55x255',
      '55x280': 'гофра 55x280',
      '55x300': 'гофра 55x300',
      '60x100': 'гофра 60x100',
      '60x115': 'гофра 60x115',
      '60x150': 'гофра 60x150',
      '60x200': 'гофра 60x200',
      '60x230': 'гофра 60x230',
      '60x250': 'гофра 60x250',
      '60x280': 'гофра 60x280',
      '64x100': 'гофра 64x100',
      '64x150': 'гофра 64x150',
      '64x200': 'гофра 64x200',
      '64x220': 'гофра 64x220',
      '64x250': 'гофра 64x250',
      '70x150': 'гофра 70x150',
    },
  },
  'Гальмівна система': {
    'Гальмівні трубки': {
      '100 мм': '100mm',
      '150 мм': '150mm',
      '200 мм': '200mm',
      '250 мм': '250mm',
      '300 мм': '300mm',
      '320 мм': '320mm',
      '350 мм': '350mm',
      '380 мм': '380mm',
      '390 мм': '390mm',
      '400 мм': '400mm',
      '450 мм': '450mm',
      '460 мм': '460mm',
      '480 мм': '480mm',
      '500 мм': '500mm',
      '510 мм': '510mm',
      '540 мм': '540mm',
      '550 мм': '550mm',
      '590 мм': '590mm',
      '600 мм': '600mm',
      '640 мм': '640mm',
      '650 мм': '650mm',
      '670 мм': '670mm',
      '700 мм': '700mm',
      '750 мм': '750mm',
      '760 мм': '760mm',
      '800 мм': '800mm',
      '850 мм': '850mm',
      '860 мм': '860mm',
      '900 мм': '900mm',
      '950 мм': '950mm',
      '960 мм': '960mm',
      '1000 мм': '1000mm',
      '1100 мм': '1100mm',
      '1190 мм': '1190mm',
      '1200 мм': '1200mm',
      '1250 мм': '1250mm',
      '1300 мм': '1300mm',
      '1400 мм': '1400mm',
      '1500 мм': '1500mm',
      '1550 мм': '1550mm',
      '1700 мм': '1700mm',
      '1800 мм': '1800mm',
      '1900 мм': '1900mm',
      '2000 мм': '2000mm',
      '2010 мм': '2010mm',
      '2100 мм': '2100mm',
      '2200 мм': '2200mm',
      '2300 мм': '2300mm',
      '2350 мм': '2350mm',
      '2400 мм': '2400mm',
      '2500 мм': '2500mm',
      '2600 мм': '2600mm',
      '2700 мм': '2700mm',
      '2800 мм': '2800mm',
      '2900 мм': '2900mm',
      '2950 мм': '2950mm',
      '3000 мм': '3000mm',
      '3100 мм': '3100mm',
      '3200 мм': '3200mm',
      '3300 мм': '3300mm',
      '3400 мм': '3400mm',
      '3500 мм': '3500mm',
      '3600 мм': '3600mm',
      '3700 мм': '3700mm',
      '3800 мм': '3800mm',
      '3900 мм': '3900mm',
      '4000 мм': '4000mm',
      '4100 мм': '4100mm',
      '4200 мм': '4200mm',
      '4300 мм': '4300mm',
      '4400 мм': '4400mm',
      '4500 мм': '4500mm',
      '4600 мм': '4600mm',
      '4700 мм': '4700mm',
      '4800 мм': '4800mm',
      '4900 мм': '4900mm',
      '5000 мм': '5000mm',
    },
    Перехідники: {
      Перехідник: 'Переходник*',
    },
  },
  'Кріпильні елементи': {
    Хомути: {
      Звичайні: {
        '6 мм': '6mm',
        '8 мм': '8mm',
        '10 мм': '10mm',
        '12 мм': '12mm',
        '16 мм': '16mm',
        '20 мм': '20mm',
        '25 мм': '25mm',
        '30 мм': '30mm',
        '32 мм': '32mm',
        '35 мм': '35mm',
        '38 мм': '38mm',
        '40 мм': '40mm',
        '50 мм': '50mm',
        '60 мм': '60mm',
        '70 мм': '70mm',
        '80 мм': '80mm',
        '90 мм': '90mm',
        '100 мм': '100mm',
        '120 мм': '120mm',
        '130 мм': '130mm',
        '140 мм': '140mm',
        '220 мм': '220mm',
      },
      Регульовані: {
        '6-10 мм': '6-10',
        '8-12 мм': '8-12',
        '10-16 мм': '10-16',
        '12-18 мм': '12-18',
        '12-22 мм': '12-22',
        '16-25 мм': '16-25',
        '16-27 мм': '16-27',
        '20-32 мм': '20-32',
        '25-40 мм': '25-40',
        '25-45 мм': '25-45',
        '30-45 мм': '30-45',
        '30-50 мм': '30-50',
        '32-58 мм': '32-58',
        '35-50 мм': '35-50',
        '38-58 мм': '38-58',
        '40-60 мм': '40-60',
        '50-70 мм': '50-70',
        '60-80 мм': '60-80',
        '70-90 мм': '70-90',
        '80-100 мм': '80-100',
        '90-110 мм': '90-110',
        '120-140 мм': '120-140',
        '130-150 мм': '130-150',
        '140-160 мм': '140-160',
        '220-240 мм': '220-240',
      },
    },
    'U-подібні хомути': {
      '38 мм': '38mm',
      '40 мм': '40mm',
      '42 мм': '42mm',
      '45 мм': '45mm',
      '48 мм': '48mm',
      '50 мм': '50mm',
      '52 мм': '52mm',
      '54 мм': '54mm',
      '56 мм': '56mm',
      '58 мм': '58mm',
      '60 мм': '60mm',
      '65 мм': '65mm',
      '70 мм': '70mm',
      '75 мм': '75mm',
    },
    'Стрімени ресори': {
      Стрімень: 'Стремянка',
    },
    Стяжка: 'Стяжка',
  },
  'Паливна система': {
    'Паливні шланги': {
      '3 мм': '3mm',
      '4 мм': '4mm',
      '5 мм': '5mm',
      '6 мм': '6mm',
      '7 мм': '7mm',
      '8 мм': '8mm',
      '10 мм': '10mm',
      '12 мм': '12mm',
    },
  },
  'Для СТО': {
    'Піддон для зливу масла': 'Тазик',
    'Торцева головка': {
      '1/2" / 10 мм': 'KABE1610',
      '1/2" / 12 мм': 'KABE1612',
      '1/2" / 13 мм': 'KABE1613',
      '1/2" / 14 мм': 'KABE1614',
      '1/2" / 15 мм': 'KABE1615',
      '1/2" / 16 мм': 'KABE1616',
      '1/2" / 17 мм': 'KABE1617',
      '1/2" / 18 мм': 'KABE1618',
      '1/2" / 19 мм': 'KABE1619',
      '1/2" / 21 мм': 'KABE1621',
      '1/2" / 22 мм': 'KABE1622',
      '1/2" / 24 мм': 'KABE1624',
      '1/2" / 27 мм': 'KABE1627',
      '1/2" / 30 мм': 'KABE1630',
      '1/2" / 32 мм': 'KABE1632',
      '1/2" / 36 мм': 'KABA1636',
      '3/4" / 19 мм': 'KABE2419',
      '3/4" / 24 мм': 'KABE2424',
      '3/4" / 27 мм': 'KABE2427',
      '3/4" / 28 мм': 'BAEA2428',
      '3/4" / 30 мм': 'BAEA2430',
      '3/4" / 32 мм': 'BAEA2432',
      '3/4" / 36 мм': 'BAEA2436',
      '3/4" / 38 мм': 'BAEA2438',
      '3/4" / 41 мм': 'BAEA2441',
      '3/4" / 46 мм': 'BAEA2446',
      '3/4" / 50 мм': 'BAEA2450',
      '3/4" / 55 мм': 'BAEA2455',
      '1" / 38 мм': 'KABA3238',
    },
    'Торцева головка TORX': {
      '1/4" Е-4': 'BAED0804',
      '1/4" Е-5': 'BAED0805',
      '1/4" Е-6': 'BAED0806',
      '1/4" Е-7': 'BAED0807',
      '1/4" Е-8': 'BAED0808',
      '1/4" Е-10': 'BAED0810',
      '1/2" Е-10': 'BAED1610',
      '1/2" Е-11': 'BAED1611',
      '1/2" Е-12': 'BAED1612',
      '1/2" Е-14': 'BAED1614',
      '1/2" Е-16': 'BAED1616',
      '1/2" Е-18': 'BAED1618',
      '1/2" Е-20': 'BAED1620',
      '1/2" Е-22': 'BAED1622',
      '1/2" Е-24': 'BAED1624',
    },
    'Набор мідних шайб': 'YT-06871',
    Біти: {
      'Біта крестова': 'fsmb0802',
      'Біта 12 лучева': 'FSFB1205',
      'Біта шестигранна': 'FSDA0812',
      'Біта шестилучева': 'FSEA0825',
    },
    Бокорез: 'DEBE204E',
    Вороток: 'AFAO2414',
    Гайкорез: 'DAAX1A16',
    Пінцет: 'JJAV0411',
    'Знімач масляного фільтра': 'JDAA0808',
    Штангенциркуль: 'Штангенциркуль',
  },
  МОТО: {
    'Щітка для очищення ланцюга': 'W612',
    'Засіб чистки шлема': '102992',
    'Масло мото вилки': '821901',
    'Антифриз мото': '111762',
    'Смазка ланцюга': '815516',
    'Промивка масляної системи мото': 'XA40201',
  },
}

export default fastSearchData
